import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@shared/services/custom-navigation.service';

@Component({
  // eslint-disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private translate: TranslateService,
    public navigationService: NavigationService
  ) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang);
    // this.googleAnalyticsScript(environment.gaTrackingId);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  // googleAnalyticsScript(gaTrackingId: string) {
  //   const gTagManagerScript = document.createElement('script');
  //   gTagManagerScript.async = true;
  //   gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
  //   document.head.appendChild(gTagManagerScript);
  //   const gaScript = document.createElement('script');
  //   gaScript.innerHTML = `
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { dataLayer.push(arguments); }
  //   gtag('js', new Date());
  //   gtag('config', '${gaTrackingId}', { send_page_view: false });
  // `;
  //   document.head.appendChild(gaScript);
  // }
}
